import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-ma-sm q-pa-sm" }
const _hoisted_2 = { class: "q-mb-md" }

import { computed, ref, onMounted } from 'vue';

// Personal components
import QPageTitle from '@components/QPageTitle.vue';

// Personal libs
import {
  convertSecondsInFinestTime,
} from '@shared/lib/date.lib';
import { sessionManager } from '@shared/service/sessionManager/session-manager.class';
import { TokenStatusEnum } from '@shared/enum/token-status.enum';
import {
  SessionInteractionEnum,
  SessionStatusEnum,
} from '@shared/enum/session-manager.enum';
import { IDataTime } from '@shared/interface/cronjob.interface';
import { getFingerPrint } from '@shared/lib/fingerprint.lib';

/**
 * Reactive data
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'SessionPage',
  setup(__props) {

// Vendor
const fingerprint = ref<string>()

/**
 * Computed
 */
const isOnline = computed<boolean>(() => sessionManager.isOnline.value === true);
const sessionStatus = computed<SessionStatusEnum | undefined>(
  () => sessionManager.sessionStatus.value,
);
const sessionInteractionStatus = computed<SessionInteractionEnum | undefined>(
  () => sessionManager.sessionInteractionStatus.value,
);
const accessTokenStatus = computed<TokenStatusEnum | undefined>(
  () => sessionManager.accessToken.tokenStatus.value,
);
const accessTokenRemainingTime = computed<number | undefined>(
  () => sessionManager.accessToken.remainingTime.value,
);
const accessTokenRemainingDataTime = computed<IDataTime | undefined>(
  () => sessionManager.accessToken.remainingDataTime.value,
);
const refreshTokenStatus = computed<TokenStatusEnum | undefined>(
  () => sessionManager.refreshToken.tokenStatus.value,
);
const refreshTokenRemainingTime = computed<number | undefined>(
  () => sessionManager.refreshToken.remainingTime.value,
);
const refreshTokenRemainingDataTime = computed<IDataTime | undefined>(
  () => sessionManager.refreshToken.remainingDataTime.value,
);

/**
 * Hooks
 */
onMounted(async () => {
  fingerprint.value = (await getFingerPrint())?.fingerprint
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(QPageTitle, { title: `Session` }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, " Serveur distant joignable : " + _toDisplayString(isOnline.value ? 'oui' : 'non'), 1 /* TEXT */),
      _createElementVNode("div", null, [
        _createTextVNode(" Session : "),
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, " Session status : " + _toDisplayString(sessionStatus.value ? _unref(SessionStatusEnum)[sessionStatus.value] : 'null'), 1 /* TEXT */),
          _createElementVNode("li", null, " Session interaction status : " + _toDisplayString(sessionInteractionStatus.value
              ? _unref(SessionInteractionEnum)[sessionInteractionStatus.value]
              : 'null'), 1 /* TEXT */),
          _createElementVNode("li", null, "Current fingerprint : " + _toDisplayString(fingerprint.value), 1 /* TEXT */)
        ])
      ]),
      _createElementVNode("div", null, [
        _createTextVNode(" Access Token : "),
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, " Status : " + _toDisplayString(accessTokenStatus.value ? _unref(TokenStatusEnum)[accessTokenStatus.value] : 'null'), 1 /* TEXT */),
          _createElementVNode("li", null, " Secondes restantes : " + _toDisplayString(accessTokenRemainingTime.value ? accessTokenRemainingTime.value : 'null'), 1 /* TEXT */),
          _createElementVNode("li", null, " Temps restant : " + _toDisplayString(_unref(convertSecondsInFinestTime)(accessTokenRemainingDataTime.value)), 1 /* TEXT */)
        ])
      ]),
      _createElementVNode("div", null, [
        _createTextVNode(" Refresh Token : "),
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, " Status : " + _toDisplayString(refreshTokenStatus.value ? _unref(TokenStatusEnum)[refreshTokenStatus.value] : 'null'), 1 /* TEXT */),
          _createElementVNode("li", null, " Secondes restantes : " + _toDisplayString(refreshTokenRemainingTime.value ? refreshTokenRemainingTime.value : 'null'), 1 /* TEXT */),
          _createElementVNode("li", null, " Temps restant : " + _toDisplayString(_unref(convertSecondsInFinestTime)(refreshTokenRemainingDataTime.value)), 1 /* TEXT */),
          _createElementVNode("li", null, " Fingerprint : " + _toDisplayString(_unref(sessionManager).refreshToken.getFingerprint()), 1 /* TEXT */)
        ])
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}
}

})